import React from 'react';
import OrderFormRoot, { OrderFormProps, OrderFormState, PriceType, UrnDetailType } from './OrderFormRoot';
import toMoney from '../util/tomoney';
import toDisplayTimestamp from '../util/display-timestamp';
//import { OrderDataInterface } from '../types/order';
import { AcquireDataHome, AcquireDataOffice, OrderData, OrderDataItem, OrderDataItemDataNamePlate, OrderDataItemDataUrn, OrderDataItemPriceData, OrderDataPayment, ReleaseDataHome, ReleaseDataOffice } from '../classes/order';


export interface OrderReviewProps extends OrderFormProps, OrderFormState {
  update: (f:string, v:any) => boolean;
  resetState: () => void;
  FC: any;
  createOrderRecord: OrderFormRoot["createOrderRecord"];
}


export interface ReviewState {
  total: number;
  order_data?: OrderData;

  /*
  service?: ReviewPriceLine;
  extras_urn?: ReviewPriceLine;
  extras_urn_detail?: UrnDetailType;
  extras_nameplate?: ReviewPriceLine;
  extras_pawprint?: ReviewPriceLine;
  extras_pawprint_qty?: number;
  pricings?: any;
  */
}

/*
export interface ReviewPriceLine {
  label: string;
  price: number | undefined;
  detail?: string | undefined;
}
*/

/*
export interface OrderDataPriceData {
  total: number;
  type: PriceType;
  descriptor?: string;
  price?: number;
  units?: number;
}
*/


/*
export interface OrderDataInfo {
  pet_name: string;
  pet_species: string;
  weight: number;
  owner_name: string;
  owner_phone: string;
  owner_email: string;
}
*/


class OrderReview extends React.Component<OrderReviewProps, ReviewState> {

  state: ReviewState;

  constructor(props: OrderReviewProps) {
    super(props);

    this.state = {
      total: 0,
    };

  }


  componentDidUpdate(prevProps: any) {
    if (this.props.reviewing !== prevProps.reviewing) {
      this.createOrderRecord();
    }
  }


  render() {

    const odata = this.state.order_data;

    if (!odata) {
      return <div></div>
    }

    const acquire = odata.acquire || { detail: {} };
    const release = odata.release || { detail: {} };

    const weight_vals = this.props.convertWeight(odata.info.weight);

    const service = odata.service;
    const urn = odata.urn;
    const nameplate = odata.nameplate;
    const pawprint = odata.pawprint;
    const priority_service = odata.priority_service;
    const viewing_service = odata.viewing_service;
    const viewing_and_priority_service = odata.viewing_and_priority_service;
    const after_hours_appointment = odata.after_hours_appointment;

    return (
      <form id="OrderReviewForm" onSubmit={this.placeOrder}>

        <div className="container">

          <h2>Review your Order</h2>

          <table className="table-review">
            <tbody className="info">
              <tr className="heading">
                <th colSpan={3}>Pet/Owner Information</th>
              </tr>
              <tr>
                <td>Pet's Name</td>
                <td colSpan={2}>{odata.info.pet_name || 'N/A'}</td>
              </tr>
              <tr>
                <td>Species</td>
                <td colSpan={2}>{odata.info.pet_species || 'N/A'}</td>
              </tr>
              <tr>
                <td>Weight</td>
                <td colSpan={2}>{weight_vals[0]}lbs {weight_vals[1]}oz</td>
              </tr>
              <tr>
                <td>Owner Name</td>
                <td colSpan={2}>{odata.info.owner_name || 'N/A'}</td>
              </tr>
              <tr>
                <td>Owner Phone</td>
                <td colSpan={2}>{odata.info.owner_phone || 'N/A'}</td>
              </tr>
              <tr>
                <td>Owner Email</td>
                <td colSpan={2}>{odata.info.owner_email || 'N/A'}</td>
              </tr>
            </tbody>

            <tbody className="order">
              <tr className="heading">
                <th colSpan={3}>Order</th>
              </tr>

            {acquire.type === "home" && acquire instanceof AcquireDataHome ? (
            <tr>
              <td style={{verticalAlign: 'top'}}>Home Pickup</td>
              <td>
                
                <div><b>Pickup at:</b></div>
                <address>
                  <div>
                    {acquire.detail.name}
                  </div>
                  <div>
                    {acquire.detail.address1}
                  </div>
                  {acquire.detail.address2 ? (
                  <div>
                    {acquire.detail.address2}
                  </div>
                  ) : ''}
                  <div>
                    {acquire.detail.city}, {' '}
                    {acquire.detail.state} {' '}
                    {acquire.detail.zip}
                  </div>
                </address>
                
                <div>
                  <b>Phone:</b> {' '}
                  {acquire.detail.phone}
                </div>

                <div>
                  <b>requested time:</b> {' '}
                  {acquire.detail.requested_time ? 
                      toDisplayTimestamp(new Date(acquire.detail.requested_time).getTime() / 1000) :
                      'N/A'}
                </div>

              </td>
            </tr>
            ) : ''}


            {acquire.type === "dropoff" && acquire instanceof AcquireDataOffice ? (
            <tr>
              <td style={{verticalAlign: 'top'}}>PPMS Office Dropoff</td>
              <td>
                <div>
                  <b>requested time:</b> {' '}
                  {acquire.detail.requested_time ? 
                      toDisplayTimestamp(new Date(acquire.detail.requested_time).getTime() / 1000) :
                      'N/A'}
                </div>
              </td>
            </tr>
            ) : ''}



            {release.type === 'home' && release instanceof ReleaseDataHome ? (
            <tr>
              <td style={{verticalAlign: 'top'}}>Home Delivery</td>
              <td>
                
                <div><b>Deliver to:</b></div>
                <address>
                  <div>
                    {release.detail.name}
                  </div>
                  <div>
                    {release.detail.address1}
                  </div>
                  {release.detail.address2 ? (
                  <div>
                    {release.detail.address2}
                  </div>
                  ) : ''}
                  <div>
                    {release.detail.city}, {' '}
                    {release.detail.state} {' '}
                    {release.detail.zip}
                  </div>
                </address>
                
                <div>
                  <b>Phone:</b> {' '}
                  {release.detail.phone}
                </div>

                <div>
                  <b>requested time:</b> {' '}
                  {release.detail.requested_time ? 
                      toDisplayTimestamp(new Date(release.detail.requested_time).getTime() / 1000) :
                      'N/A'}
                </div>

                <div>
                  <b>signature required:</b> {' '}
                  {release.detail.require_signature ? 'Yes' : 'No' }
                </div>

              </td>
            </tr>
            ) : ''}


            {release.type === 'pickup' && release instanceof ReleaseDataOffice ? (
            <tr>
              <td style={{verticalAlign: 'top'}}>PPMS Office Pickup</td>
              <td>
                <div>
                  <b>requested time:</b> {' '}
                  {release.detail.requested_time ? 
                      toDisplayTimestamp(new Date(release.detail.requested_time).getTime() / 1000) :
                      'N/A'}
                </div>
              </td>
            </tr>
            ) : ''}


            {this.pricedItemRow('service', 'Service', service)}

            {this.pricedItemRow('urn', 'Keepsake Urn', urn, false, (urn && urn.data instanceof OrderDataItemDataUrn && urn.data.engraving_type ? ' - ' + urn.data.engraving_type : "") )}

            {this.pricedItemRow('nameplate', 'Engraved Nameplate', nameplate, true)}


            {(() => {
              if (nameplate && nameplate.data instanceof OrderDataItemDataNamePlate && nameplate.data.nameplate_lines) {
                return (
                  <tr>
                    <td>Engraving</td>
                    <td>
                      {nameplate.data.nameplate_lines.map((l, i) => 
                        <div key={i}>{l}</div>
                      )}
                    </td>
                  </tr>
                );
              }
            })()}

            {odata.pawprint 
              ? this.pricedItemRow('pawprint', 'Clay Pawprint', pawprint, true, (pawprint && pawprint.qty > 0 ? pawprint.qty+"" : "1")) 
              : ''}

            {odata.viewing_and_priority_service 
              ? this.pricedItemRow('viewing_and_priority_service', 'Priority Service + Viewing Service Bundle', viewing_and_priority_service, true) 
              : ''}

            {odata.priority_service 
              ? this.pricedItemRow('priority_service', 'Priority Service', priority_service, true) 
              : ''}

            {odata.viewing_service 
              ? this.pricedItemRow('viewing_service', 'Viewing Service', viewing_service, true) 
              : ''}
              
            {odata.after_hours_appointment 
              ? this.pricedItemRow('after_hours_appointment', 'After Hours Appt', after_hours_appointment, true) 
              : ''}

            {(() => {
              let feePrice = new OrderDataItemPriceData(this.props.weight || 0, odata.acquire.fees.find(f => f.type === odata.acquire.type)?.pricing, service?.tag);
              if (odata.acquire.type === 'home' && feePrice.total) {
                return (
                <tr>
                  <td>Pickup</td>
                  <td>yes</td>
                  <td>
                    {this.toMoney(feePrice.total)}
                  </td>
                </tr>
                )
              }
            })()}


            {(() => {
              let feePrice = new OrderDataItemPriceData(this.props.weight || 0, odata.release.fees.find(f => f.type === odata.release.type)?.pricing, service?.tag);
              if (odata.release.type === 'home' && feePrice.total) {
                return (
                <tr>
                  <td>Delivery</td>
                  <td>yes</td>
                  <td>
                    {this.toMoney(feePrice.total)}
                  </td>
                </tr>
                )
              }
            })()}


            {(() => {
              if (odata.comments) {
                return (
                <tr>
                  <td>Other/Request</td>
                  <td colSpan={2}>{odata.comments}</td>
                </tr>
                )
              }
            })()}


            <tr className="total">
              <td style={{verticalAlign: 'top'}}><b>Total</b></td>
              <td></td>
              <td>
                <b>{this.toMoney(odata.total)}</b>
              </td>
            </tr>

            <tr className="taxnote">
              <td colSpan={3}>
                <div className="text-center">
                  <span>Note:</span> {""}
                  taxes apply on tangible items
                </div>
              </td>
            </tr>

            </tbody>
          </table>

          {odata.service && odata.total > 0 ? this.showCheckout : ''}

        </div>
      </form>      
    );
  }


  get showCheckout() {
    const odata = this.state.order_data;
    if (!odata) return (<div></div>);

    return (
    <div>

      {odata.total > 0 ? this.showCheckoutBillMeLater : ''}

      <div className="form-group margin-top">
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          
          <button type="button" className="btn btn-secondary pull-left" onClick={this.goBack}>
            <i className="fa fa-arrow-left"></i> Go Back
          </button>

          <button type="submit" className="btn btn-primary btn-lg">
            {this.props.payment_type === 'online' ? (
              <span>Add to Cart <i className="fa fa-shopping-cart"></i></span>
            ) : (
              <span>Place Order<i className="fa fa-plus"></i></span>
            )}
            
          </button>

        </div>
      </div>

      <a id="ShowSideCartLink" href="https://preciouspetsms.foxycart.com/cart?cart=view"
        style={{ position: 'absolute', top: 0, left: '-100vw', height: 0, width: 0, opacity: 0 }}>View cart</a>

    </div>      
    )
  }


  get showCheckoutBillMeLater() {

    return (
      <div>
        <div>
          {this.props.payment_type === "contact" ? this.payLaterForm : ''}
        </div>

        <div className="form-group margin-top">
          <label>
            Payment Notes
          </label>
          <textarea className="form-control" name="payment_comment" value={this.props.payment_comment}
            rows={4}
            onChange={(e: React.FormEvent) => this.update('payment_comment', (e.target as HTMLTextAreaElement).value)}></textarea>
        </div>

      </div>
    )
  }


  get payLaterForm() {
    const odata = this.state.order_data;
    if (!odata) return (<div></div>);

    return (
      <div>
        <div className="form-group margin-top payment-later-radios">

          <label>Payment Type</label>

          <div className="frow">

            <div className="fcol option-col">
              <div className={'payment-option margin-bottom payment-option-later-cash' + (this.props.payment_type_detail === "cash" ? ' selected' : '')} 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return this.update("payment_type_detail", "cash");
                  }}>

                  <div className="sel">
                    <div className="radio">
                      <label className="form-check-label" htmlFor="option-payment-type-online-cash">
                        <input type="radio" 
                          id="option-payment-type-online-cash"
                          name="payment_type_detail" 
                          value="cash" 
                          checked={this.props.payment_type === "contact" && this.props.payment_type_detail === "cash"} 
                          onChange={(e) => {e.preventDefault(); this.update("payment_type_detail", "cash")}} />
                        {" "}
                        Cash
                      </label>
                    </div>
                  </div>

                  <div className="cont">
                    {this.state.order_data?.acquire.type === 'dropoff' ? (
                      <p>Pay in cash at the PPMS office</p>
                    ) : (
                      <p>Pay the driver in cash when your pet is picked up from you</p>
                    )}
                  </div>
              </div>
            </div>


            <div className="fcol option-col">
              <div className={'payment-option margin-bottom payment-option-later-cash' + (this.props.payment_type_detail === "check" ? ' selected' : '')} 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return this.update("payment_type_detail", "check");
                  }}>

                  <div className="sel">
                    <div className="radio">
                      <label className="form-check-label" htmlFor="option-payment-type-online-check">
                        <input type="radio" 
                          id="option-payment-type-online-check"
                          name="payment_type_detail" 
                          value="check" 
                          checked={this.props.payment_type === "contact" && this.props.payment_type_detail === "check"} 
                          onChange={(e) => {e.preventDefault(); this.update("payment_type_detail", "check")}} />
                        {" "}
                        Check
                      </label>
                    </div>
                  </div>

                  <div className="cont">
                    {this.state.order_data?.acquire.type === 'dropoff' ? (
                      <p>Pay by check at the PPMS office</p>
                    ) : (
                      <p>Pay the driver by check when your pet is picked up from you</p>
                    )}
                  </div>
              </div>
            </div>


            <div className="fcol option-col">
              <div className={'payment-option margin-bottom payment-option-later-creditcard' + (this.props.payment_type_detail === "creditcard" ? ' selected' : '')} 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return this.update("payment_type_detail", "creditcard");
                  }}>

                  <div className="sel">
                    <div className="radio">
                      <label className="form-check-label" htmlFor="option-payment-type-later-creditcard">
                        <input type="radio" 
                          id="option-payment-type-later-creditcard"
                          name="payment_type_detail" 
                          value="creditcard" 
                          checked={this.props.payment_type === "contact" && this.props.payment_type_detail === "creditcard"} 
                          onChange={(e) => {e.preventDefault(); this.update("payment_type_detail", "creditcard")}} />
                        {" "}
                        Credit Card
                      </label>
                    </div>
                  </div>

                  <div className="cont">
                    <p>We will email an online payment link to {this.props.owner_email}</p>
                  </div>
              </div>
            </div>

          </div>

        </div>


        <div className="row">
          <div className="col-lg-6">

            <div className="form-group margin-top" 
              style={{'display': (this.props.payment_type === "contact" && this.props.payment_type_detail === "cash" ? 'block' : 'none')}}>
              <label>
                Cash Amount
              </label>
              <div className="input-group">
                <span className="input-group-addon">$</span>
                <input type="number" className="form-control" name="payment_type_detail_cash" value={this.props.payment_cash_amount}
                  onChange={(e: React.FormEvent) => this.update('payment_cash_amount', (e.target as HTMLInputElement).value)} 
                  required={this.props.payment_type === "contact" && this.props.payment_type_detail === "cash"} />
              </div>
            </div>


            <div className="form-group margin-top" 
              style={{'display': (this.props.payment_type === "contact" && this.props.payment_type_detail === "check" ? 'block' : 'none')}}>
              <label>
                Check Number
              </label>
              <div className="input-group">
                <span className="input-group-addon">#</span>
                <input type="text" className="form-control" name="payment_type_detail_check" value={this.props.payment_check_number}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.update('payment_check_number', e.target.value)} 
                  required={this.props.payment_type === "contact" && this.props.payment_type_detail === "check"} />
              </div>
            </div>

          </div>
        </div>

      </div>
    )
  }


  goBack = (e:React.MouseEvent) =>{
    e.preventDefault();
    this.update('reviewing', false);
  }


  placeOrder = async(e: React.FormEvent) => {
    e.preventDefault();

    // create a new payment info object for the orderdata
    const payment = new OrderDataPayment();
    payment.type = this.props.payment_type;
    payment.payment_comment = this.props.payment_comment;

    if (this.props.payment_type === "contact" && this.props.payment_type_detail) {

      payment.type_detail = this.props.payment_type_detail;

      if (this.props.payment_type_detail === "cash") {
        payment.cash_amount = this.props.payment_cash_amount;
      } else if (this.props.payment_type_detail === "check") {
        payment.check_number = this.props.payment_check_number;
      }

    }

    const order_data = new OrderData(this.state.order_data);

    // if we have transport fees, then add them as items on the order
    let aFee = order_data.acquire.fees.find(f => f.type === order_data.acquire.type);
    let rFee = order_data.release.fees.find(f => f.type === order_data.release.type);

    if (aFee) {
      order_data.items.push(
        new OrderDataItem('acquire_fee', aFee.label, aFee.tag, 1, order_data.info.weight, aFee.pricing, undefined, order_data)
      )
    }
    if (rFee) {
      order_data.items.push(
        new OrderDataItem('release_fee', rFee.label, rFee.tag, 1, order_data.info.weight, rFee.pricing, undefined, order_data)
      )
    }

    order_data.payment = payment;

    this.setState({
      order_data
    });


    if (payment.type === "contact" || payment.type === "invoice") {
      return this.submitOrder(order_data);
    }

    return false;
  }


  submitOrder = async (odata: OrderData) => {

    odata = odata || this.state.order_data;

    if (!odata || odata.total <= 0) return;

    this.props.setLoading(true);

    let res = await this.props.callAPI('post', '/neworder', { order: odata, online_payment: false });
    if (res && res.id && res.ident) {

      this.props.addSnack({
        type: 'success',
        title: 'Order Created',
        text: `Order ${res.ident} is now in process. An email confirmation has been sent to ${odata.info.owner_email}`,
      })

      // clear the order info and go back to an empty form
      this.props.resetState();
      
      this.props.navigate(['order', res.ident, res.sec_key]);

    } else {

      this.props.addSnack({
        type: 'danger',
        title: 'Order Failed!',
        text: `There was an error placing the order!`,
        timeout: false,
      })

    }

    this.props.setLoading(false);
  }


  /*
  async submitFoxyOrder() {

    const FC = this.props.FC;
    const scl = (document.getElementById('ShowSideCartLink') as HTMLLinkElement);
    if (!scl) return;

    const odata = this.state.order_data;
    if (!odata || !odata.service || !(odata.total > 0)) return;

    this.props.setLoading(true);

    let res = await this.props.callAPI('post', '/neworder', { order: odata, online_payment: true });
    if (res && res.id && res.ident) {

      // make a urlstring for the product details to pass to foxycart
      const urldata = new Map();
      urldata.set('expires', 720);
      urldata.set('h:user', odata.user_id);
      urldata.set('code', res.ident);
      
      urldata.set('name', odata.service.label+' '+res.ident);
      urldata.set('price', this.toMoney(odata.total > 0 ? odata.total : 0, true));

      urldata.set('pet_name', odata.info.pet_name);
      urldata.set('pet_species', odata.info.pet_name);
      urldata.set('pet_weight', odata.info.weight);
      urldata.set('owner_name', odata.info.owner_name);
      urldata.set('owner_phone', odata.info.owner_phone);
      urldata.set('owner_email', odata.info.owner_email);
      urldata.set('service', odata.service.label);

      if (odata.extras.keepsake) {
        urldata.set('keepsake', odata.extras.keepsake.label);
      }
      
      if (odata.extras.nameplate) {
        urldata.set('nameplate', 'yes');
        if (odata.extras.nameplate_lines) {
          odata.extras.nameplate_lines.forEach((l, i) => {
            urldata.set('nameplate_engraving_line_'+(i+1), l.trim());
          });
        }
      }

      if (odata.extras.pawprint) {
        urldata.set('clay_pawprint', 'yes');
      }

      const qsp: string[] = [];
      for(const [k, v] of urldata.entries()) {
        qsp.push(encodeURIComponent(k) +'='+ encodeURIComponent(v))
      }
      const qs = qsp.join('&');

      FC.client.request('https://'+FC.settings.storedomain+'/cart?'+qs).done(() => {
        FC[FC.json.context].render();
        scl.click();

        // clear the order info and go back to an empty form
        this.props.resetState();
        this.props.setLoading(false);

        this.props.addSnack({
          type: 'success',
          title: 'Added to Cart',
          text: `Checkout your cart when finished to complete your orders`,
        })
  
      });

    } else {

      this.props.addSnack({
        type: 'danger',
        title: 'Order Failed!',
        text: `There was an error placing the order!`,
        timeout: false,
      })

      this.props.setLoading(false);
    }

  }
  */

  /*
  setBillMeLater = (e: React.FormEvent) => {
    const radio = (e.target as HTMLInputElement);
    const val = radio.value === 'later' ? 'later' : 'online';
    this.update('payment_type', val);
  }


  setPaymentTypeDetail = (e: React.FormEvent) => {
    const radio = (e.target as HTMLInputElement);
    const val = radio.value;
    this.update('payment_type_detail', val);
  }
  */


  update = (field: string, val: any) => {
    this.props.update(field, val)
  }



  pricedItemRow(type: string, itemName: string, p: OrderDataItem | undefined, boolLabel?: boolean, qty?: string) {

    if (!p) return;

    let label = '';
    if (boolLabel) {
      if (qty) {
        label = 'qty: '+qty;
      } else {
        label = 'yes';
      }
    } else {
      label = p.label;
      if (qty) {
        label += " "+qty;
      }
    }

    let price = p.price;
    let price_additional = p.price_additional || 0;

    if (type === 'urn' && p.data instanceof OrderDataItemDataUrn && p.data.engraving_price > 0) {
      price += p.data.engraving_price;
    }


    let total = 0;
    if (p.priceData.type === 'fixed_additional') {
      total = price;
      if (p.qty > 1) {
        total += (p.qty - 1) * price_additional;
      }
    } else {
      total = price * (p.qty || 1);
    }

    return (
      <tr>
        <td>{itemName}</td>
        <td>{label}</td>
        <td>
          {this.toMoney(total)}
        </td>
      </tr>
    )

  }



  createOrderRecord() {
    this.setState({
      order_data: this.props.createOrderRecord(),
    })
  }


  toMoney(cents:number, nosign?: boolean) {
    return toMoney(cents, nosign);
  }

}


export default OrderReview;
